import Vue from 'vue'
import Vuex from 'vuex'
// vue-cookies配置
import VueCookies from 'vue-cookies'
import music from './modules/music'
import image from './modules/image'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        navList: [], // 菜单数据
        menuList: [], // 当前选中的二级菜单数据
        buttonData: {}, // 按钮权限数据
        menuItem: VueCookies.get('menuItem') || {}, // 当前激活菜单的item
        activePath: VueCookies.get('activePath') || '',
        userInfo: VueCookies.get('userInfo') ? VueCookies.get('userInfo') : {},
        activeIndex: VueCookies.get('activeIndex') ? VueCookies.get('activeIndex') : 0,
        isCollapse: false, // 菜单折叠状态
        showPopover: true, // 悬浮菜单显隐
        tagsView: {},
        permission: {},
        settings: {},
        tabList: [], // tab 标签页记录
        visitorData: VueCookies.get('visitorRes') || {},
        modelList: [], // 当前菜单的模型列表
        currentModel: VueCookies.get('currentModel') || null, // 当前选中的模型
        tokenCount: null, // 当前模型的token数量

        // 跳转项目信息
        sourceProduct: VueCookies.get('sourceProduct') || null
    },
    getters: {
        // 获取当前模型列表
        getModelList: (state) => {
            return state.modelList
        },
        // 获取当前选中的模型
        getCurrentModel: (state) => {
            return state.currentModel
        },
        // 获取当前token数量
        getTokenCount: (state) => {
            return state.tokenCount
        }
    },
    mutations: {
        // 更新菜单折叠状态
        renewCollapse(state, status) {
            state.showPopover = !status
            state.isCollapse = status
        },
        // 更新悬浮菜单显隐
        renewShowPopover(state, status) {
            state.showPopover = status
        },

        // 更新菜单列表
        renewNavList(state, data) {
            state.navList = data
        },
        // 更新菜单列表
        renewMenuList(state, data) {
            state.menuList = data
        },
        // 更新按钮权限数据
        renewButtonData(state, data) {
            state.buttonData = data
        },
        // 更新激活菜单对象
        renewMenuItem(state, data) {
            state.menuItem = data
        },
        // 修改左侧菜单栏路径
        changeActivePath(state, path) {
            state.activePath = path
        },
        // 修改顶部菜单栏索引
        changeActiveIndex(state, index) {
            state.activeIndex = index
        },
        // 更新用户信息
        renewUserInfo(state, data) {
            state.userInfo = data
        },
        // 更新菜单折叠状态
        renewCollapse(state, status) {
            state.isCollapse = status
        },
        // 更新 tab 标签页记录
        renewTabList(state, data) {
            state.tabList = data
        },
        updateVisitorData(state, data) {
            state.visitorData = data
        },
        // 设置模型列表
        setModelList(state, data) {
            state.modelList = data
        },
        // 设置当前选中的模型
        setCurrentModel(state, data) {
            state.currentModel = data
        },
        // 设置token数量
        setTokenCount(state, count) {
            state.tokenCount = count
        },
        // 设置来源项目信息
        setSourceProduct(state, data) {
            state.sourceProduct = data
            if (data) {
                VueCookies.set('sourceProduct', data)
            } else {
                VueCookies.remove('sourceProduct')
            }
        }
    },
    actions: {},
    modules: {
        music,
        image
    }
})
